import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { AnnouncementsPage } from './AnnouncementsPage';
import { AnnualUpdatePage } from './AnnualUpdatePage';
import { AuditLogsPage } from './AuditLogsPage';
import { ManualPage } from './ManualPage';
import { ManualsPage } from './ManualsPage';

/**
 * 管理機能（S-90, S-93〜S-95）と操作マニュアル。パスは `/years/:year` からの相対。
 * （ユーザー管理 S-91 は features/admin-users、マスタ管理 S-92 は features/masters）
 */
export const routes: RouteObject[] = [
  {
    path: 'admin/annual-update',
    handle: { crumb: '年次更新処理' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <AnnualUpdatePage />
      </RequireAuth>
    ),
  },
  {
    path: 'admin/announcements',
    handle: { crumb: 'お知らせ管理' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <AnnouncementsPage />
      </RequireAuth>
    ),
  },
  {
    path: 'admin/manuals',
    handle: { crumb: 'マニュアル管理' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <ManualsPage />
      </RequireAuth>
    ),
  },
  {
    path: 'admin/audit-logs',
    handle: { crumb: '操作ログ' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <AuditLogsPage />
      </RequireAuth>
    ),
  },
  { path: 'manual', handle: { crumb: '操作マニュアル' } satisfies RouteHandle, element: <Outlet />, children: [{ index: true, element: <ManualPage /> }] },
];
